/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { FiPlusSquare, FiSearch, FiUser, FiUserPlus, FiUserX } from 'react-icons/fi'
import { message } from 'antd'
import { motion } from 'framer-motion'
import PropagateLoader from 'react-spinners/PropagateLoader'

import { AiFillGooglePlusCircle, AiFillHome } from 'react-icons/ai'
import { FaDiscord, FaMinusCircle } from 'react-icons/fa'

import { Container, Logo, Links, Search } from './styles'

import api from '../../services/api'
import SearchItem from '../SearchItem'

function Menu() {
  const navigate = useNavigate()

  const [search, setSearch] = useState('')
  const [searchLoading, setSearchLoading] = useState(true)
  const [data, setData] = useState([])

  async function listPlugins() {
    if (search.length > 3) {
      try {
        const result = await api.get(`/plugin/search?q=${encodeURIComponent(search)}`)
        setData(result.data)
      } catch (err) {
        message.error(err?.response?.data?.message)
      }
      setSearchLoading(false)
    }
  }

  function useDebounce(callback, timeout, deps) {
    const timeoutId = useRef()

    useEffect(() => {
      clearTimeout(timeoutId.current)
      timeoutId.current = setTimeout(callback, timeout)

      return () => clearTimeout(timeoutId.current)
    }, deps)
  }

  useDebounce(listPlugins, 1000, [search])

  let { id } = useParams()

  async function loadParams() {
    if (id) {
      try {
        const result = await api.get(`/plugin/search?q=${encodeURIComponent(id)}`)
        setData(result.data)
        setSearchLoading(false)
      } catch (err) {
        message.error(err.response.data.message)
      }
    }
  }

  useEffect(() => {
    loadParams()
  }, [])

  return (
    <Container>
      <Logo onClick={() => navigate('/')} />
      <Links>
        <li className="icon-link" title="Início">
          <Link to="/">
            <AiFillHome />
          </Link>
        </li>
        <li className="discord-channel" title="Discord">
          <a
            href={process.env.REACT_APP_DISCORD_INVITE || "https://discord.gg/atlasplugins"}
            target="_blank"
            rel="noreferrer noopener"
          >
            <FaDiscord />
          </a>
        </li>
      </Links>
      <Search>
        <input
          placeholder="Procurando por algum plugin específico?"
          value={search}
          onChange={(e) => {
            setSearchLoading(true)
            setSearch(e.target.value)
          }}
        />
        <button className="search-btn">
          <FiSearch />
        </button>
        {(search.length > 3 || id) && (
          <motion.ul
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {searchLoading ? (
              <li style={{ justifyContent: 'center', alignItems: 'center' }}>
                <PropagateLoader size={5} color={'#0192d4'} />
              </li>
            ) : data.length > 0 ? (
              data.map((el) => (
                <SearchItem
                  data={el}
                  key={el.id}
                  onDetailsClick={() => {
                    setSearch('')
                  }}
                />
              ))
            ) : (
              <li>Não encontramos resultado para "{search}"</li>
            )}
          </motion.ul>
        )}
      </Search>
      <Links className="ml-auto" >
        <li className="account" title="Minha conta" style={{ background: 'var(--background-color) !important' }}>
          <Link to="/login">
            <FiUser />
          </Link>
        </li>
      </Links>
    </Container>
  )
}

export default Menu
